import type { ReactNode } from "react";
import { cn } from "../../lib/utils";
import { Avatar } from "./Avatar";
import { Badge } from "./Badge";

export function RoomSectionTab({
  label,
  icon,
  active,
  newContent = false,
  onClick,
  className,
}: {
  label: string;
  icon: ReactNode;
  active: boolean;
  /** Show a new-content dot on the avatar (e.g. when section has an article < 7 days old) */
  newContent?: boolean;
  onClick: () => void;
  className?: string;
}): React.JSX.Element {
  const activeAvatarClass =
    "border-[1.5px] border-solid border-ds-primary bg-ds-primary text-ds-white";
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex w-16 shrink-0 flex-col items-center gap-2",
        className
      )}
    >
      <Badge show={newContent} position="tl">
        <Avatar
          variant="icon"
          icon={icon}
          size="md"
          className={cn(
            "transition-colors duration-150 ease-out",
            active ? activeAvatarClass : "bg-ds-slate-100 text-ds-slate-500"
          )}
          badge={null}
        />
      </Badge>
      <span
        className={cn(
          "text-center font-medium text-xs/tight",
          "transition-colors duration-150 ease-out",
          active ? "text-primary-black" : "text-ds-slate-500"
        )}
      >
        {label}
      </span>
    </button>
  );
}
